import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import Sidebar from './components/Sidebar';
import Clients from './pages/clients/Clients';
import Invoices from './pages/billing/Invoices';
import Bookings from './pages/bookings/Bookings';
import Estimates from './pages/billing/Estimates';
import Settings from './pages/profile/Settings';
import Account from './pages/profile/Account';
import Products from './pages/products/Products';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import theme from './theme';
import "./App.scss";
import ProductAdd from './pages/products/ProductAdd';
import ClientAdd from './pages/clients/ClientAdd';
import BookingCreate from './pages/bookings/BookingCreate';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import BookingDetails from './pages/bookings/BookingDetails';
import ProductEdit from './pages/products/ProductEdit';
import ClientDetails from './pages/clients/ClientDetails';
import ClientEdit from './pages/clients/ClientEdit';
import Options from "./pages/options/Options";
import OptionAdd from "./pages/options/OptionAdd";
import OptionEdit from "./pages/options/OptionEdit";
import {AuthProvider} from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/admin/AdminRoute";
import AdminSidebar from "./components/admin/AdminSidebar";
import CreateCompany from "./pages/admin/CreateCompany";
import Companies from "./pages/admin/Companies";
import Users from "./pages/admin/Users";
import CreateUser from "./pages/admin/CreateUser";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Payments from "./pages/billing/Payments";
import NotFound from "./pages/NotFound";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <CssBaseline/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Routes>
                            <Route path="/login" element={<Login/>}/>
                            <Route path="/forgot-password" element={<ForgotPassword/>}/>
                            <Route path="/reset-password" element={<ResetPassword/>}/>

                            <Route path="/admin/" element={
                                <AdminRoute>
                                    <AdminSidebar/>
                                </AdminRoute>
                            }>
                                {/* Admin routes */}
                                <Route path="companies" element={<Companies/>}/>
                                <Route path="companies/create" element={<CreateCompany/>}/>
                                <Route path="users" element={<Users/>}/>
                                <Route path="users/create" element={<CreateUser/>}/>
                            </Route>

                            <Route path="/" element={
                                <PrivateRoute>
                                    <Sidebar/>
                                </PrivateRoute>
                            }>
                                <Route index element={<Dashboard/>}/>
                                <Route path="clients" element={<Clients/>}/>
                                <Route path="clients/add" element={<ClientAdd/>}/>
                                <Route path="clients/edit/:id" element={<ClientEdit/>}/>
                                <Route path="clients/details/:id" element={<ClientDetails/>}/>
                                <Route path="estimates" element={<Estimates/>}/>
                                <Route path="bookings" element={<Bookings/>}/>
                                <Route path="bookings/details/:id" element={<BookingDetails/>}/>
                                <Route path="bookings/create" element={<BookingCreate/>}/>
                                <Route path="bookings/edit/:id" element={<BookingCreate/>}/>
                                <Route path="invoices" element={<Invoices/>}/>
                                <Route path="payments" element={<Payments/>}/>
                                <Route path="settings" element={<Settings/>}/>
                                <Route path="account" element={<Account/>}/>
                                <Route path="login" element={<Login/>}/>
                                <Route path="products" element={<Products/>}/>
                                <Route path="products/add" element={<ProductAdd/>}/>
                                <Route path="products/edit/:id" element={<ProductEdit/>}/>
                                <Route path="options" element={<Options/>}/>
                                <Route path="options/add" element={<OptionAdd/>}/>
                                <Route path="options/edit/:id" element={<OptionEdit/>}/>
                                <Route path="*" element={<NotFound/>}/>
                            </Route>
                        </Routes>
                    </LocalizationProvider>
                </ThemeProvider>
            </BrowserRouter>
        </AuthProvider>);
}
